<template>
  <ion-content
    :scroll-events="true"
    @ionScroll="handleScroll($event)"
    class="scroller default-background"
    v-if="!loading || isLoadMore"
  >
    <!-- Add All to Cart Button for History Tab -->
    <div
      v-if="selectedTabCategory === 'history' && list.items && list.items.length > 0"
      class="add-all-section mx-3 mt-3"
    >
      <ion-button
        expand="block"
        fill="solid"
        color="primary"
        :disabled="isAddingAllToCart"
        @click="addAllToCart"
        class="add-all-button"
      >
        <ion-icon slot="start" :icon="cartOutline" v-if="!isAddingAllToCart"></ion-icon>
        <ion-spinner slot="start" v-if="isAddingAllToCart"></ion-spinner>
        {{ isAddingAllToCart ? $t('adding_to_cart') : $t('add_all_to_cart') }}
      </ion-button>
    </div>

    <NewProductItem
      :key="item.id"
      :item="item"
      :user="user"
      :selectedCompany="selectedCompany"
      v-for="item in list.items || []"
      @item-clicked="toProductDetail"
    />

    <!-- INFINITY scroll -->
    <ion-infinite-scroll
      @ionInfinite="loadMore"
      threshold="100px"
      id="infinite-scroll"
      :disabled="isDisabled"
    >
      <div class="d-flex justify-center align-center pb-2" v-if="isShowLoading && !isConnectionIssue">
        <ion-spinner name="bubbles"></ion-spinner>
        <ion-text class="ml-1">{{ $t('please_wait') }}...</ion-text>
      </div>
    </ion-infinite-scroll>
    <div v-if="!loading && list.items.length === 0 && !isFirstRenderPage" class="company-not-found mx-4">
      <ion-img src="/assets/images/not-found.svg" class="not-found-img" />
      <div
        class="not-found-text mt-3 mb-2"
        v-html="
          isConnectionIssue
            ? $t('unable_load')
            : $t('sorry_not_found', {
                search_keyword: search.searchQueries === '' ? refKeySearch : search.searchQueries
              })
        "
      ></div>
      <div class="try-different">
        {{ isConnectionIssue ? $t('please_make_sure_connected') : $t('try_different_keyword') }}
      </div>
    </div>
  </ion-content>

  <div v-if="loading && !isLoadMore">
    <skeleton-product-item v-for="(item, index) in 4" :key="index" :detail="false" class="mx-3 my-3" />
  </div>
</template>
<script>
import halal from '@/assets/images/sale/home/halal.svg';
import NewProductItem from '@/components/product-item/NewCardProductItem.vue';
import { getItemByKey, useUpdateFilter } from '@/components/sort/composable';
import { TYPE_SEARCH, defaultSize } from '@/modules/sale/constants';
import {
  discountFn,
  marketPriceFn,
  priceDiscountFn,
  priceFn,
  weightFn
} from '@/modules/sale/services/libs/home';
import { ACTIONS as ACTIONS_CART } from '@/modules/sale/store/cart/actions';
import { ACTIONS } from '@/modules/sale/store/product/actions';
import {
  GETTER,
  INPUT_QUANTITY_BY_WEIGHT,
  MODULES_FILTER,
  OFFSET_LIST_DEFAULT
} from '@/modules/shared/constants/';
import { useAlert } from '@/modules/shared/utils';
import { useConfig, useGetStorageData } from '@/usecases/';
import { Capacitor } from '@capacitor/core';
import { Keyboard } from '@capacitor/keyboard';
import { toastController } from '@ionic/vue';
import { cartOutline, checkmarkOutline } from 'ionicons/icons';
import { computed, defineAsyncComponent, defineComponent, ref } from 'vue';
import { useRoute } from 'vue-router';
import { createNamespacedHelpers } from 'vuex';
const { mapActions, mapGetters } = createNamespacedHelpers('sale/product');
const { mapGetters: mapGettersCustomer } = createNamespacedHelpers('sale/customer');
const { mapActions: mapActionsCart } = createNamespacedHelpers('sale/cart');
export default defineComponent({
  components: {
    // components
    SkeletonProductItem: defineAsyncComponent(() => import('./SkeletonProductItem.vue')),
    NewProductItem
  },

  props: {
    changeCategory: {
      type: String,
      default: ''
    },
    selectedNewCustomer: {
      type: Object,
      default: null
    }
  },
  emits: ['fetchAllProduct', 'load-data', 'item-clicked', 'reloadHomePage'],
  setup(props, { emit }) {
    const { router, t, store } = useConfig();
    const { selectedCompany: selectedCompanyOnStorage } = useGetStorageData();
    const { createAlert } = useAlert();
    const isOpenRef = ref(false);
    const setOpen = (state) => (isOpenRef.value = state);
    const user = ref(null);
    const selectedCompany = ref(null);
    const category = ref(null);
    const isShowList = ref(false);
    const isShowLoading = ref(false);
    const route = useRoute();
    const isFirstRenderPage = ref(true);
    const { onSetDefaultSort, updateFilter } = useUpdateFilter();
    const tenantId = ref(0);
    const productId = ref(0);
    const selectedTabCategory = ref(props.changeCategory);
    const listCompanies = computed(() => store.getters[`sale/customer/list`]);

    const validateCustomerData = async () => {
      const { id, account_number } = await selectedCompanyOnStorage.value;
      if (!id || !account_number) {
        if (listCompanies.value?.items?.length <= 1) {
          createAlert(
            t('missing_customer_data_label'),
            t('missing_customer_data_desc'),
            () => emit('reloadHomePage'),
            t('refresh')
          );
          return;
        } else {
          createAlert(
            t('missing_customers_data_label'),
            t('missing_customers_data_desc'),
            () => router.replace('/sale/select-customer'),
            t('selectCompany.select_company')
          );
          return;
        }
      }
    };
    return {
      validateCustomerData,
      onSetDefaultSort,
      updateFilter,
      isOpenRef,
      setOpen,
      user,
      selectedCompany,
      category,
      isShowList,
      isShowLoading,
      route,
      priceFn,
      weightFn,
      priceDiscountFn,
      marketPriceFn,
      discountFn,
      halal,
      checkmarkOutline,
      cartOutline,
      isFirstRenderPage,
      tenantId,
      productId,
      selectedTabCategory,
      Keyboard,
      isSample: ref(false),
      catelogies: ref(null),
      listItem: ref(null),
      previousSearchPerform: ref(null),
      refKeySearch: ref(``),
      isDisabled: ref(false),
      isConnectionIssue: ref(false),
      isAddingAllToCart: ref(false)
    };
  },
  computed: {
    ...mapGetters(['list', 'loading', 'isLoadMore', 'search', 'resetCategory', 'getProductStatus']),
    ...mapGettersCustomer(['selectedCustomer']),

    currencySymbol() {
      return this.user ? this.user.currency_symbol : '';
    }
  },

  watch: {
    selectedCustomer: {
      async handler(newCompany, oldCompany) {
        if (oldCompany && newCompany && newCompany.id !== oldCompany.id) {
          this.selectedTabCategory = 'history';
          this.selectedCompany = newCompany;
        }
      },
      deep: true
    },
    async selectedNewCustomer() {
      await this.onSearch('history');
    },
    'list.totalCount'() {
      this.isFirstRenderPage = false;
      this.isDisabled = false;
    },
    'search.mainCategoryId': {
      handler() {
        if (this.catelogies != this.search.mainCategoryId) {
          this.isSample = false;
        }
      },
      deep: true
    },
    getProductStatus() {
      let isError = this.getProductStatus;
      this.isConnectionIssue =
        isError === this.$t('load_failed') || isError === this.$t('failed_to_fetch') ? true : false;
    },
    async search() {
      this.isShowList = false;
      this.category = this.selectedTabCategory;
      this.search.searchQueries !== '' ? (this.refKeySearch = this.search.searchQueries) : '';

      await this[ACTIONS.GET_PRODUCTS]({
        isLoadMore: this.isLoadMore
      });

      if (this.list.totalCount === 0 || this.list.totalCount === this.list.items.length) {
        this.isDisabled = true; // remove spriner
      }
    },
    list() {
      this.isDisabled = false;
      this.list.category == this.category ? (this.isShowList = true) : '';
      this.isShowLoading =
        this.list.totalCount !== 0 && this.list.totalCount > this.list.items.length ? true : false;
      if (this.list.totalCount === 0 || this.list.totalCount === this.list.items.length) {
        this.isDisabled = true; // remove spriner
      }
    },
    resetCategory() {
      this.category = null;
    },
    changeCategory() {
      this.selectedTabCategory = this.changeCategory;
    }
  },

  inject: ['$storage'],

  async mounted() {
    this.user = await this.$storage.getUser();
    this.selectedCompany = await this.$storage.getSelectedCompany();
    if (this.changeCategory !== '') {
      this.selectedTabCategory = this.changeCategory;
      await this.onSearch(this.selectedTabCategory);
    } else {
      this.selectedTabCategory = 'history';
      await this.onSearch(this.selectedTabCategory);
    }
  },

  methods: {
    async loadMore(e) {
      try {
        if (this.NoLoadItems) return;

        this.NoLoadItems = true;
        // check continue status
        if (this.list.totalCount !== 0 && this.list.totalCount === this.list.items.length) {
          this.isDisabled = true;
          return;
        }
        await this.getProduct();
        e.target.complete();
      } catch (error) {
        this.NoLoadItems = true;
      } finally {
        this.NoLoadItems = false;
      }
    },
    getProduct() {
      this.$emit('load-data');
    },
    ...mapActions([ACTIONS.UPDATE_SEARCH, ACTIONS.GET_PRODUCTS, ACTIONS.CHOOSE_PRODUCT]),
    ...mapActionsCart([ACTIONS_CART.ADD_ITEM_TO_CART]),
    changeSample() {
      this.isSample = !this.isSample;
    },
    async onSearch(cate) {
      await this.validateCustomerData();
      if (this.selectedNewCustomer) {
        this.selectedCompany = this.selectedNewCustomer;
      }
      this.isShowList = false;

      // update category
      this.category = this.selectedTabCategory;

      if (this.search.isExplore) {
        this.search.isExplore = false;

        // update filter to most popular
        this.updateFilter(this.search.sortBy);

        // perform search
        await this[ACTIONS.GET_PRODUCTS]({
          isLoadMore: false,
          search: this.search
        });
      } else {
        this.onSetDefaultSort(cate);
        const sortItemKey = this.$store.getters[`${MODULES_FILTER}/${GETTER.GET_FILTER}`];
        const itemSort = getItemByKey({ categoryName: cate, key: sortItemKey });
        const search = {
          searchQueries: '',
          sortBy: cate === 'history' ? 'purchased' : itemSort.sortBy,
          sortType: cate === 'history' ? 'desc' : itemSort.sortType,
          mainCategoryId: cate,
          tenantId: this.user.tenant.id + '',
          buyerId: this.selectedCompany.id + '',
          halal: this.selectedCompany.halal_products,
          account_number: this.selectedCompany.account_number,
          limit: defaultSize,
          offset: OFFSET_LIST_DEFAULT,
          isSample: this.isSample
        };
        await this[ACTIONS.UPDATE_SEARCH]({ search, type: TYPE_SEARCH.CATEGORY });
      }
      this.isShowList = true;
    },

    handleScroll(event) {
      if (event && Capacitor.isNativePlatform()) {
        this.Keyboard.hide();
      }
    },

    fetchAllProduct() {
      this.$emit('fetchAllProduct');
    },
    toProductDetail(item) {
      this.$router.push({ path: `/sale/main/product-detail/${item.id}` });
    },
    async openToast(message, color = 'primary', position = 'top') {
      const toast = await toastController.create({
        message,
        position,
        color,
        duration: 2000
      });
      return toast.present();
    },
    async addAllToCart() {
      if (!this.list.items || this.list.items.length === 0) {
        return;
      }

      this.isAddingAllToCart = true;

      try {
        // Add each item to cart with default quantity of 1
        for (const item of this.list.items) {
          // Skip items without skus data
          if (!item.skusData || item.skusData.length === 0) {
            continue;
          }

          // For each product, add the first available SKU (or the default SKU for single variants)
          const firstAvailableSku = item.skusData.find((sku) => !sku.is_out_of_stock) || item.skusData[0];

          // Skip if no available SKU found or it's out of stock
          if (!firstAvailableSku || firstAvailableSku.is_out_of_stock) {
            continue;
          }

          const cartItem = {
            sku_id: firstAvailableSku.sku_id,
            is_favorite: firstAvailableSku.is_favorite || false,
            quotation_status: firstAvailableSku.quotation_status || null,
            supplier_id: this.selectedCompany.id,
            order_qty: firstAvailableSku.is_order_by_weight ? INPUT_QUANTITY_BY_WEIGHT : 1, // Default quantity 1
            order_weight: firstAvailableSku.weight || 1.0,
            selected: true
          };

          const params = {
            customer_id: this.selectedCompany.id,
            delivery_date: null,
            delivery_time: null,
            standalone: false,
            item: cartItem
          };

          await this[ACTIONS_CART.ADD_ITEM_TO_CART](params);
        }

        // Show success message
        await this.openToast(this.$t('all_items_added_to_cart'), 'primary');

        // Navigate to cart
        this.$router.push('/sale/cart');
      } catch (error) {
        console.error('Error adding items to cart:', error);
        await this.openToast(this.$t('error_adding_items_to_cart'), 'danger');
      } finally {
        this.isAddingAllToCart = false;
      }
    }
  }
});
</script>

<style lang="scss" scoped>
ion-item::part(native) {
  padding: 0;
}
.scroller {
  height: 100%;
  --padding-top: 16px;
  --padding-bottom: 16px;
}

.default-background {
  --background: #f5f5f5;
}
.product-image::part(image) {
  width: 63px;
  height: 63px;
}

.company-not-found {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow-y: hidden;
  margin-top: 12vh;
}
.not-found-img {
  height: 120px;
  width: 120px;
}
.not-found-text {
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  letter-spacing: 0.7px;
}
.try-different {
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  text-align: center;
  letter-spacing: 0.7px;
}

.name {
  font-weight: 500;
  font-size: 16px;
  white-space: pre-wrap;
  line-height: 20px;
}

.tenant {
  font-size: 1rem;
}

.price {
  font-size: 0.7rem;
  font-weight: 400;
  line-height: 1.25rem;
  letter-spacing: 0.03333em;
  color: var(--ion-color-grey);
}

.weight {
  font-size: 1rem;
  color: var(--ion-color-primary);
}

.marketPrice {
  font-size: 0.72rem;
  color: var(--ion-color-grey);
  text-decoration: line-through;
}

.discount {
  background: #fff1f1;
  color: #e56b68;
  border-radius: 3px;
  padding-left: 3px;
  padding-right: 3px;
  font-size: 0.72rem;
}
.logo-halal {
  width: 30px;
  height: 30px;
}
.quoted {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end !important;
  & > div {
    & > .title {
      color: #00676a;
      font-size: 12px;
      position: relative;
      & > ion-icon {
        padding-top: 10px;
        position: absolute;
        bottom: 2px;
        font-size: 14px;
        left: 0;
      }
      & > ion-text {
        display: flex;
        justify-content: flex-end;
      }
    }
    & > ion-text {
      display: flex;
      font-size: 10px;
      line-height: 12px;
      color: #667085;
      justify-content: flex-end;
    }
  }
}

.add-all-section {
  margin-bottom: 16px;
}

.add-all-button {
  --border-radius: 8px;
  height: 44px;
  font-weight: 500;
}
</style>
